import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";
import { ScanPointTimeScanRequest } from "../../shared/ScanPointTimeScanRequest";
import * as moment from "moment";

@Component({
	selector: "caass-scan-point-manual-mark-time",
	templateUrl: "./scan-point-manual-mark-time.component.html",
	styleUrls: ["./scan-point-manual-mark-time.component.css"],
})
export class ScanPointManualMarkTimeComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.CurrentTime = moment(this.ScanDT).format("h:mm A");
		this.CurrentDate = moment(this.ScanDT).format("MM/DD/YYYY");

		this.loadManualOptions();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	@Input() FacilityID: number;
	@Input() FacilityLocationID: number;
	@Input() Receipt_IDPrinterID: number;
	@Input() TimeScanTypeID: number;
	@Input() SelectedPerson: any;
	AudienceMode: string = "Student";

	@Output() CancelMarkTime: EventEmitter<any> = new EventEmitter();
	@Output() ManualScan: EventEmitter<ScanPointTimeScanRequest> = new EventEmitter();

	//Scan DT
	ScanDT: Date = new Date();
	CurrentTime: string = "";
	CurrentDate: string = "";

	//Top Options
	@Input() TimeScanTypeDesc: string = "";
	IDStatus: any;
	lstReasons: any = [];
	Comments: string = "";

	//ID Printing
	OptionsLoading: boolean = true;

	PrintNewCard: boolean = false;
	PrintTempCard: boolean = false;

	ChargeIDCardFee: boolean = false;
	IDCardFee: any = 0.0;
	IDCardFeeDisplay: string = "$0.00";
	ChargeTempID: boolean = false;
	TempIDFee: any = 0.0;
	TempIDFeeDisplay: string = "$0.00";
	FineTotal: any = 0.0;
	FineMax: any = 0.0;
	AmountPaid: any = 0.0;

	//Override Menu
	Override: boolean = false;

	Processing: boolean = false;
	ErrorMessage: any = "";

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadManualOptions() {
		this.OptionsLoading = true;

		var result = this.scanService.ScanPointManualOptionsSelect(this.SelectedPerson.PersonID);
		result.subscribe(
			(response: any) => {
				var Data: any = response;

				this.lstReasons = Data.lstReasons;
				this.IDStatus = this.lstReasons[0];

				this.ChargeIDCardFee = Data.ChargeIDCardFee == null ? false : Data.ChargeIDCardFee;
				this.IDCardFee = Data.IDCardFee == null ? 0.0 : Data.IDCardFee;
				this.ChargeTempID = Data.ChargeTempID == null ? false : Data.ChargeTempID;
				this.TempIDFee = Data.TempIDFee == null ? 0.0 : Data.TempIDFee;
				this.FineTotal = Data.FineTotal == null ? 0.0 : Data.FineTotal;

				this.FineMax = this.FineTotal;
				this.IDCardFeeDisplay = "$" + this.IDCardFee.toFixed(2);
				this.TempIDFeeDisplay = "$" + this.TempIDFee.toFixed(2);

				this.OptionsLoading = false;
			},
			(error) => {
				this.OptionsLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////
	onMarkTime() {
		this.ErrorMessage = "";

		//Error Handling
		if (this.AmountPaid == undefined) {
			this.AmountPaid = 0;
		}
		if (this.AmountPaid < 0) {
			this.AmountPaid = 0;
		}
		if (this.AmountPaid > this.FineMax) {
			this.AmountPaid = this.FineMax;
		}

		if (this.Comments.length > 300) {
			this.ErrorMessage = "Comments can't be more than 300 characters. " + (this.Comments.length - 300) + " characters remaining";
			return;
		}

		this.Processing = true;

		var parms: ScanPointTimeScanRequest = {
			Barcode: "MANUAL",
			FacilityID: this.FacilityID,
			FacilityLocationID: this.FacilityLocationID,
			TimeScanTypeID: this.TimeScanTypeID,
			Receipt_IDPrinterID: this.Receipt_IDPrinterID,
			IsManual: 1,
			Scan_PersonID: this.SelectedPerson.PersonID,
			Override: this.Override == true ? 1 : 0,
			IDStatusID: this.IDStatus.IDStatus,
			ManualComment: this.Comments,
			ReprintCardInd: this.PrintNewCard == true ? 1 : 0,
			PrintedTempInd: this.PrintTempCard == true ? 1 : 0,
			ChargeReprintFeeInd: this.ChargeIDCardFee == true ? 1 : 0,
			ChargeTempFeeInd: this.ChargeTempID == true ? 1 : 0,
			PaidAmount: this.AmountPaid.toFixed(2),
			ReprintFee: this.IDCardFee,
			TempIDFee: this.TempIDFee,
		};

		this.ManualScan.emit(parms);
	}

	onCancel() {
		this.CancelMarkTime.emit(true);
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////
	onReasonChange(val) {
		this.IDStatus = val;
	}

	onPrintNewCardChange(val) {
		this.PrintNewCard = val;

		this.CalculateMax();
	}

	onChargeIDCardFeeChange(val) {
		this.ChargeIDCardFee = val;

		this.CalculateMax();
	}

	onPrintTempCardChange(val) {
		this.PrintTempCard = val;

		this.CalculateMax();
	}

	onChargeTempIDChange(val) {
		this.ChargeTempID = val;

		this.CalculateMax();
	}

	CalculateMax() {
		this.FineMax = this.FineTotal;

		if (this.PrintNewCard == true && this.ChargeIDCardFee == true) {
			this.FineMax += this.IDCardFee;
		}
		if (this.PrintTempCard == true && this.ChargeTempID == true) {
			this.FineMax += this.TempIDFee;
		}

		if (this.AmountPaid > this.FineMax) {
			this.AmountPaid = this.FineMax;
		}
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////
	GetFineTotal() {
		var numFT: number = this.FineTotal;

		if (this.PrintNewCard == true && this.ChargeIDCardFee == true) {
			numFT += this.IDCardFee;
		}
		if (this.PrintTempCard == true && this.ChargeTempID == true) {
			numFT += this.TempIDFee;
		}

		numFT -= this.AmountPaid;

		return "$" + numFT.toFixed(2);
	}

	IsLoading() {
		return this.OptionsLoading == true || this.Processing == true;
	}

	CausesNewIDInd() {
		if (this.IDStatus == null) {
			return false;
		} else {
			return this.IDStatus.CausesNewIDInd;
		}
	}
	/////////////////////////////////////////////////////////////////
}
